import { useStaticQuery, graphql } from 'gatsby';

export const useImageQuery = () => {
	const imagesData = useStaticQuery(graphql`
		query ImageQuery {
			allImageSharp {
				edges {
					node {
						id
						fluid {
							...GatsbyImageSharpFluid
						}
					}
				}
			}
		}
  `);
	return imagesData;
};

